module.exports = __webpack_public_path__ + "img/mercado-livre.142a8627.png";